import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthorizationServicesEnum, OwsClientService, OwsJSON, OwsServiceErrorResponse } from 'ows-library';
import { PopUpService } from 'app/compartilhado/componentes/pop-up/pop-up.service';
import { Router } from '@angular/router';
import { GlobalService } from 'app/compartilhado/servicos/global.service';
import { ProvedorCobrancaNome } from '../agendamento-go-form/models/ProvedorCobrancaNomeEnum';
import { DadosPagamentoModel } from '../agendamento-go-form/models/DadosPagamento.model';
import { PagamentoService } from 'app/compartilhado/componentes/pagamento-form/pagamento.service';

export class ConfirmarPesquisaModel {
  EmpresaId = '';
  EmpresaCnpj = '';
  EmpresaNome = '';
  EmpresaCep = '';
  EmpresaUF = '';
  EmpresaLogradouro = '';
  EmpresaComplemento = '';
  EmpresaBairro = '';
  EmpresaNumero = '';
  EmpresaMunicipio = '';
  Placa = '';
  Renavam = '';
  CpfCnpj = '';
  Nome = '';
  VeiculoPorte = '';
  Email = '';
  TelefoneDDD = '';
  Telefone = '';
  Status = '';
  DataHoraInicio = '';
  DataHoraFim = '';
  RecaptchaSiteKey = '';
}

export class ConfirmarRepostaModel {
  ProvedorCobrancaChave: string;
  AgendamentoVistoriaId: string;
  PossuiProvedorCobrancaChave: boolean;
  PossuiProvedorCobrancaChaveSecundaria: boolean;
  VistoriaValor: string;
  ProvedorCobrancaNome: ProvedorCobrancaNome;
}

@Injectable()
export class AgendamentoService {

  listaMunicipios = [];
  listaLocaisVistoria = [];
  municipiosChanged = new Subject<any>();
  locaisVistoriaChanged = new Subject<any>();
  agendamentosChanged = new Subject<any>();
  cadastroChanged = new Subject<any>();
  pagamentoChanged = new Subject<any>();
  exibirBotoesChanged = new Subject<any>();
  creditoFormChanged = new Subject<any>();
  informacoesLocalSelecionadoChanged = new Subject<any>();
  falhaPagamentoChanged = new Subject<any>();
  ufAgendamento;
  tipoVistoriaAgendamento;
  municipioAgendamento;
  localVistoriaAgendamento;
  listaTiposVeiculos = [{
    Key: 'PE', Value: 'Pequeno'
  }, {
    Key: 'ME', Value: 'Médio'
  }, {
    Key: 'GR', Value: 'Grande'
  }];
  listaTiposVistoria = [{ Key: '1', Value: 'Vistoria em Posto Fixo' }];
  pesquisaFlag = false;
  consultaPorCnpj = false;
  realizaPagamento = false;
  agendamentoId;
  cartaoCreditoTokenId = '';
  vistoriaValor;
  dadosPagamento: DadosPagamentoModel = new DadosPagamentoModel();
  confirmaResposta: ConfirmarRepostaModel = new ConfirmarRepostaModel();
  exibePagina = true;
  checkoutUrl;
  provedorCobranca = ProvedorCobrancaNome.ND;
  recaptchaValueMemory;
  agendamentoDados: ConfirmarPesquisaModel = new ConfirmarPesquisaModel();

  constructor(private owsClientService: OwsClientService,
    private popUpService: PopUpService,
    private globalService: GlobalService,
    private pagamentoService: PagamentoService,
    private router: Router) {
  }

  obterMunicipios(tipoVistoria, uf) {
    this.owsClientService.get<any>('agendamentosvistorias/listarmunicipios', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [
        { key: 'tipoVistoria', value: tipoVistoria },
        { key: 'uf', value: uf }]
    }).subscribe((response) => {
      this.listaMunicipios = response.body.Municipios;
      this.municipiosChanged.next(response.body.Municipios);
    },
      error => {
        this.pesquisaFlag = false;
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }

  consultarEmpresaPorCnpj(cnpj) {
    this.owsClientService.get<any>('agendamentosvistorias/listarlocaisvistoriasporcnpj', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [
        { key: 'cnpj', value: cnpj },
        { key: 'uf', value: 'PI' }]
    }).subscribe((response) => {
      this.listaLocaisVistoria = response.body.LocaisVistorias;
      this.locaisVistoriaChanged.next(response.body.LocaisVistorias);
    },
      error => {
        this.pesquisaFlag = false;
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }

  obterLocaisVistoria(municipioCodigo, municipioNome, uf) {
    this.owsClientService.get<any>('agendamentosvistorias/listarlocaisvistorias', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [
        { key: 'municipioCodigo', value: municipioCodigo.toString() },
        { key: 'municipioNome', value: municipioNome },
        { key: 'uf', value: uf }]
    }).subscribe((response) => {
      this.listaLocaisVistoria = response.body.LocaisVistorias;
      this.locaisVistoriaChanged.next(response.body.LocaisVistorias);
    },
      error => {
        this.pesquisaFlag = false;
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }

  efetuarPagamentoCielo() {
    this.dadosPagamento.AgendamentoId = this.agendamentoId;
    this.dadosPagamento.ProvedorCobrancaNome = this.provedorCobranca;
    this.dadosPagamento.VistoriaValor = this.vistoriaValor;
    this.owsClientService.post<any>('agendamentosvistorias/pagamento', this.dadosPagamento, {
      authorizationService: AuthorizationServicesEnum.None
    }).subscribe(resposta => {
      this.pesquisaFlag = false;
      if (resposta.body && resposta.body.CheckoutUrl) {
        this.checkoutUrl = resposta.body.CheckoutUrl;
        this.pagamentoChanged.next(resposta.body.CheckoutUrl);
      } else {
        this.pagamentoChanged.next(false);
      }
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
        this.pesquisaFlag = false;
      });
    }

  efetuarPagamentoCreditoIugu(pagamentoTipo: string) {
    this.pagamentoService.efetuarPagamentoCreditoIugu(pagamentoTipo);
  }

  efetuarPagamentoIuguPixBoleto(pagamentoTipo: string) {
    if (pagamentoTipo == 'C' && this.cartaoCreditoTokenId !== '') {
      this.dadosPagamento.CartaoCreditoTokenId = this.cartaoCreditoTokenId;
    }
    this.dadosPagamento.ProvedorCobrancaNome = this.provedorCobranca;
    this.dadosPagamento.AgendamentoId = this.agendamentoId;
    this.dadosPagamento.VistoriaValor = this.vistoriaValor;
    this.dadosPagamento.PagamentoTipo = pagamentoTipo;
    this.owsClientService.post<any>('agendamentosvistorias/pagamento', this.dadosPagamento, {
      authorizationService: AuthorizationServicesEnum.None
    }).subscribe(resposta => {
      this.pesquisaFlag = false;
      if (resposta.body && resposta.body.CheckoutUrl) {
        this.checkoutUrl = resposta.body.CheckoutUrl;
        this.pagamentoChanged.next(this.checkoutUrl);
      } else {
        this.pagamentoChanged.next(false);
      }
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
        this.globalService.exibirLoadingPagamento(false);
        this.pesquisaFlag = false;
        
        //2116: Campo CPF/CNPJ Inválido.
        if (error.error && error.error.Code == 2116) {
          this.falhaPagamentoChanged.next();
        }

        if (pagamentoTipo == 'C') {
          this.exibePagina = true;
          this.creditoFormChanged.next();
        }
      });
  }

  obterAgendamentosEmpresa(data, empresaId) {
    this.owsClientService.get<any>('agendamentosvistorias/listarhorariosmarcadosdia', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [{ key: 'empresaId', value: empresaId },
      { key: 'data', value: data }]
    }).subscribe((response) => {
      this.agendamentosChanged.next(response.body.AgendamentosEmpresa);
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }

  confirmarAgendamento() {
    this.pesquisaFlag = true;
    this.owsClientService.post<ConfirmarRepostaModel>('agendamentosvistorias/confirmar', this.agendamentoDados, {
      authorizationService: AuthorizationServicesEnum.None
    }).subscribe(resposta => {
      this.confirmaResposta = resposta.body;
      this.vistoriaValor = this.confirmaResposta.VistoriaValor;
      this.agendamentoId = this.confirmaResposta.AgendamentoVistoriaId;

      if (this.confirmaResposta.ProvedorCobrancaNome !== null) {
        if (this.confirmaResposta.ProvedorCobrancaNome == ProvedorCobrancaNome.CIELO) {
          this.realizaPagamento = this.confirmaResposta.PossuiProvedorCobrancaChave;
          this.provedorCobranca = ProvedorCobrancaNome.CIELO;
        } else if (this.confirmaResposta.ProvedorCobrancaNome == ProvedorCobrancaNome.IUGU) {
          this.realizaPagamento = this.confirmaResposta.PossuiProvedorCobrancaChave || this.confirmaResposta.PossuiProvedorCobrancaChaveSecundaria;
          this.provedorCobranca = ProvedorCobrancaNome.IUGU;
        }
      }
      this.cadastroChanged.next(true);
      this.pesquisaFlag = false;
    },
      error => {
        // 2094 - O horário escolhido não está mais disponível. Favor selecionar um novo horário.
        // 2121 - O dia escolhido não está mais disponível. Favor selecionar um novo dia.
        if (error.error && (error.error.Code === 2094 || error.error.Code === 2121)) {
          // this.obterAgendamentosEmpresa(this.agendamentoDados.Da formClone.DataInicio.toLocaleDateString('pt-BR'), agendamentoDados.EmpresaId);
          this.obterAgendamentosEmpresa(this.agendamentoDados.DataHoraInicio, this.agendamentoDados.EmpresaId);
          
        }
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
        this.pesquisaFlag = false;
      });
  }

  formatarTelefone(telefone) {
    const telefoneAjustado = telefone.replace(/(\d{2})(\d{5})(\d{4})/,
      function (regex, arg1, arg2, arg3) {
        return arg1 + ' ' + arg2 + '-' + arg3;
      });
    return telefoneAjustado;
  }

  exibirBotoesPagamento() {
    this.exibirBotoesChanged.next(true);
  }

  transfereDadosServicos() {
    if (this.confirmaResposta.PossuiProvedorCobrancaChave) {
      this.pagamentoService.dadosPagamento = this.dadosPagamento;
      this.pagamentoService.dadosPagamento.Nome = this.dadosPagamento.Nome;
      this.pagamentoService.dadosPagamento.Email = this.dadosPagamento.Email;
      this.pagamentoService.dadosPagamento.CpfCnpj = this.dadosPagamento.CpfCnpj;
      this.pagamentoService.dadosPagamento.TelefoneDDD = this.dadosPagamento.TelefoneDDD;
      this.pagamentoService.dadosPagamento.Telefone = this.dadosPagamento.Telefone;
      this.pagamentoService.dadosPagamento.EmpresaId = this.dadosPagamento.EmpresaId;
      this.pagamentoService.dadosPagamento.AgendamentoId = this.agendamentoId;
      this.pagamentoService.dadosPagamento.Placa = this.dadosPagamento.Placa;
      this.pagamentoService.dadosPagamento.CartaoCreditoTokenId = '';
      this.pagamentoService.dadosPagamento.PagamentoTipo = '';
      this.pagamentoService.dadosPagamento.VistoriaValor = this.vistoriaValor;
      this.pagamentoService.dadosPagamento.ProvedorCobrancaNome = this.confirmaResposta.ProvedorCobrancaNome;
      this.pagamentoService.provedorCobrancaChave = this.confirmaResposta.ProvedorCobrancaChave;
    }
  }

  obterInformacoesLocalSelecionado(localId: string) {
    this.owsClientService.get<any>('agendamentosvistorias/localselecionado/informacoes', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [{ key: 'localId', value: localId }]
    }).subscribe((response) => {
      this.informacoesLocalSelecionadoChanged.next(response.body);
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }
}